.card {
  --_pad: var(--s-7);

  display: block;
  box-sizing: border-box;
  padding: var(--_pad);
  border-radius: var(--r-card);
  border: var(--bw-hair) solid var(--border-hair);
  background: var(--surface-card);
  color: var(--text-body);
  text-decoration: none;
  transition: box-shadow var(--dur-base) var(--ease-standard);
}
.card[data-padding="none"] {
  --_pad: 0;
}
.card[data-padding="sm"] {
  --_pad: var(--s-5);
}
.card[data-padding="lg"] {
  --_pad: var(--s-8);
}
.card[data-radius="panel"] {
  border-radius: var(--r-panel);
}
.card[data-radius="xl"] {
  border-radius: var(--r-xl);
}

/* Hundida: la feature card sobre una sección blanca. Sin borde: la separa el fondo. */
.card[data-tone="sunken"] {
  background: var(--surface-sunken);
  border-color: transparent;
}
.card[data-tone="brand"] {
  background: var(--surface-brand-faint);
  border-color: var(--border-brand-soft);
}
/* Destacada: sin borde, con la sombra de tarjeta (el testimonio destacado). */
.card[data-tone="elevated"] {
  border-color: transparent;
  box-shadow: var(--sh-sm);
}
/* Bloque oscuro y banner accent: llevan la clase de scope (`klavia-dark` / `klavia-accent`),
   así que adentro los tokens semánticos ya están flipeados y `--surface-page` es el fondo del bloque. */
.card[data-tone="inverse"],
.card[data-tone="accent"] {
  background: var(--surface-page);
  border-color: transparent;
  border-radius: var(--r-panel);
  color: var(--text-body);
}

.card[data-interactive] {
  cursor: pointer;
}
@media (hover: hover) {
  .card[data-interactive]:hover {
    box-shadow: var(--sh-sm);
  }
  .card[data-interactive][data-tone="elevated"]:hover {
    box-shadow: var(--sh-md);
  }
}
.card[data-interactive]:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}

@media (prefers-reduced-motion: reduce) {
  .card {
    transition: none;
  }
}
